<template>
  <div>
    <portal to="search">
      <div class="flex items-center">
        <h1 class="font-bold text-2xl">Customer Orders</h1>
      </div>
    </portal>

    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="flex-grow mr-4" @reset="reset">

        <template v-slot:inline>
          <div class="md:flex md:flex-grow md:items-center md:mx-12">
            <label class="block text-gray-700 whitespace-nowrap mr-2">Quoted Amount</label>
            <input v-model.number="form.quote_amount" class="mt-1 w-full form-input" type="number" step="0.10" />
          </div>
        </template>



        <label class="block text-gray-700">Status</label>
        <select v-model="form.status" class="mt-1 w-full form-select">
          <option :value="null">All</option>
          <option v-for="(status, key) in statuses" :value="key">{{ status }}</option>
        </select>

        <label class="block text-gray-700">Account Type</label>
        <select v-model="form.ctype" class="mt-1 w-full form-select">
          <option :value="null">All</option>
          <option value="b">Business</option>
          <option value="i">Individual</option>
        </select>

        <label class="block text-gray-700 mt-2">Location</label>
        <select v-model="form.location" class="mt-1 w-full form-select">
          <option :value="null">All</option>
          <option v-for="(location, key) in locations" :value="key">{{ location }}</option>
        </select>

        <label class="block text-gray-700 mt-2">Delivery/Collection</label>
        <select v-model="form.handover_type" class="mt-1 w-full form-select">
          <option :value="null">All</option>
          <option value="delivery">Delivery</option>
          <option value="collect">Customer Collect</option>
        </select>
      </search-filter>

      <div class="flex items-center gap-x-3">
      <inertia-link class="btn-primary" :href="route('customer.orders.create')">
        <span>Create</span>
        <span class="hidden md:inline">Order</span>
      </inertia-link>
      <inertia-link :href="route('delivery-notes.schedules')" target="_blank" class="btn-primary">Delivery Schedule </inertia-link>
      </div>
    </div>

    <div class="mb-4 hidden md:block">
      <div>
        <div class="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow md:grid-cols-4 xl:grid-cols-8">
          <div v-for="(card, index) in statCards" :class="{'border-t border-gray-200 md:border-0 md:border-l': index > 0}">
            <div class="px-4 py-2 sm:p-3">
              <dl>
                <dt class="text-base leading-6 font-normal text-gray-900">
                  {{ statuses[card] }}
                </dt>
                <dd class="mt-1 flex justify-between items-baseline sm:block md:flex">
                  <div class="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                    {{ stats[card] ? stats[card] : 0}}
<!--                    <span class="ml-2 text-sm leading-5 font-medium text-gray-500">-->
<!--                from 70,946-->
<!--              </span>-->
                  </div>

                  <button class="btn-primary px-3 py-2" :disabled="!stats[card]" @click="form.status = card">View</button>
<!--                  <div class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">>-->
<!--                    -->
<!--                  </div>-->
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
<!--        <button @click="form.status = null"  class="px-2.5 py-2 bg-gray-400 text-white text-sm font-bold rounded-full mr-1" :class="{'bg-indigo-500': filters.status === null}">All</button>-->
<!--        <button v-for="(status, value) in statuses" class="px-2.5 py-2 bg-gray-400 text-white text-sm font-bold rounded-full mr-1" :class="{'bg-indigo-500': filters.status === value}" @click="form.status = value">{{ status }}</button>-->
    </div>

    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Customer</th>
          <th class="px-6 pt-6 pb-4">Created By</th>
          <th class="px-6 pt-6 pb-4">TQTY</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Status</th>
        </tr>
        <tr v-for="order in items" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('customer.orders.show', order.id)">
              {{ order.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('customer.orders.show', order.id)">
              {{ order.customerAccount.name }} <span v-if="order.customerAccount.personal_account" class="mx-2 text-xs px-1 py-1 bg-blue-100 text-blue-700 rounded">Personal</span>
            </inertia-link>
          </td>
          <td class="border-t">
            <div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800">{{ order.customerAccount.location }}</div>
            <div v-if="order.customer_to_collect === false" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs bg-green-200 text-green-800" title="Delivery Order">D</div>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex flex-col justify-center" :href="route('customer.orders.show', order.id)" tabindex="-1">
              <template v-if="order.createdBy">
                <div class="text-xs text-gray-500 mb-2">{{ order.createdBy.customer === true ? 'Customer' : 'Staff' }}</div>
                <div>{{ `${order.createdBy.first_name} ${order.createdBy.last_name}` }}</div>
              </template>
              <template v-else>
                <div class="text-xs text-gray-500 mb-2">User Deleted</div>
              </template>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('customer.orders.show', order.id)" tabindex="-1">
              {{ order.items_total_qty }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('customer.orders.show', order.id)" tabindex="-1">
              {{ statuses[order.status] }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('customer.orders.show', order.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="items.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No orders found.</td>
        </tr>
      </table>
    </div>

    <pagination :links="orders.links"></pagination>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import {mapValues} from 'lodash'
import SearchFilter from '@/Shared/SearchFilter'
import debounce from 'lodash/debounce'
import pickBy from 'lodash/pickBy'
import Pagination from '@/Shared/Pagination'

export default {
  components: {Pagination, Icon, SearchFilter},
  metaInfo: { title: 'Customer Orders' },
  layout: Layout,

  props: {
    orders: Object,
    filters: Object,
    statuses: Object,
    ordersClosed: Boolean,
    locations: Object,
    statCards: Array,
    stats: Object
  },

  watch: {
    form: {
      handler: debounce(function() {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('customer.orders', Object.keys(query).length ? query : { remember: 'forget'}), {}, { preserveState: true })
      }, 300),
      deep: true,
    }
  },

  data() {
    return {
      form: {
        quote_amount: this.filters.quote_amount,
        search: this.filters.search,
        status: this.filters.status,
        location: this.filters.location,
        handover_type: this.filters.handover_type,
        ctype: this.filters.ctype
      },
    }
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    }
  },

  computed: {
    items() {
      return this.orders.data
    }
  }
}
</script>

<style scoped>

</style>
